<div class="avail">
  @if (showDetails) {
    <label>Вам&nbsp;доступно</label>
  }

  <div>
    @if (!storeService.getConditionalBalance()) {
      @let cnt = productService.countAvailability(product);

      @if (cnt > 0) {
        {{ productService.countAvailability(product).toLocaleString() }} <span class="unit">{{ unitHeader }}</span>
      } @else {
        -
      }

      @if (showDetails) {
        <div [nbPopover]="wms" nbPopoverTrigger="hover">
          <tui-icon icon="circle-alert"/>
        </div>
      }

    } @else {
      <div class="table-basket-num" [ngClass]="productService.classAvailability(product)">
        <span></span>
      </div>
    }
  </div>
</div>

<ng-template #wms>
  <div [nbSpinner]="loading" class="wms-modal popup">
    <h6>Всего {{ productService.countAvailability(product).toLocaleString() }} <span class="unit">{{ unitHeader }}</span></h6>

    @let packs = packs$ | async;

    @if (packs) {
      @if (packs?.isPack) {
        @for (pack of packs.productPacksList; track pack) {
          <div>
            @if (pack.productPacks?.length) {
              <table class="ngx-table__table--tiny ngx-table">
                <tr>
                  <th i18n="@@Warehouse">Склад</th>
                  <th i18n="@@Availabilities">Наличие</th>
                </tr>
                <tr>
                  <td>{{ pack.header }}</td>
                  <td>{{ pack.freeStock | formatPriceNumber }} <span class="unit">{{ unitHeader }}</span></td>
                </tr>
                <tr>
                  <th i18n="@@Packing">Тара, производитель</th>
                  <th i18n="@@FreeOnStock">Свободно</th>
                </tr>
                @for (item of pack.productPacks; track item) {
                  <tr>
                    <td>{{ item.header }}</td>
                    <td>{{ item.stock | formatPriceNumber }} <span class="unit">{{ unitHeader }}</span></td>
                  </tr>
                }
              </table>
            }
          </div>
        }
      } @else {
        @if (packs?.productRemain?.length) {
          <table class="ngx-table__table--tiny ngx-table">
            <tr>
              <th i18n="@@Warehouse">Склад</th>
              <th i18n="@@Availabilities">Наличие</th>
            </tr>
            @for (pack of packs.productRemain; track pack) {
              @if (pack.freeStock > 0) {
                <tr>
                  <td>{{ pack.header }}</td>
                  <td>{{ pack.freeStock  | formatPriceNumber }} <span class="unit">{{ unitHeader }}</span></td>
                </tr>
              }
            }
          </table>
        }
      }
      <div style="white-space: nowrap">
        @if (packs?.suppleStock > 0) {
          <div>Остатки у производителя - {{ packs.suppleStock | formatPriceNumber }} <span class="unit">{{ unitHeader }}</span></div>
          @if (packs.suppleTerm) {
            <div>Срок поставки - {{ packs.suppleTerm }} д.</div>
          }
        }
        <div i18n="@@WarehouseStatus">Складской статус - <span> {{ packs.statusHeader }}</span></div>
        @if (multiplicityOrder > 1) {
          <div i18n="@@MultiplicityOrder">Кратность заказа - <span> {{ multiplicityOrder | formatPriceNumber }} <span class="unit">{{ unitHeader }}</span></span></div>
        }
      </div>
    }
  </div>

</ng-template>
